import React from "react"
import LogoSvg from "../../../images/ic_logo.svg"
import DarkLogoSvg from "../../../images/ic_logo_dark.svg"
import {twMerge} from "libs/twmerge"

/**
 * @type {React.FC<React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>>}
 */
export const AppLogo = props => {
  return (
    <>
      <img
        {...props}
        className={twMerge("hidden dark:block", props.className)}
        src={DarkLogoSvg}
      />
      <img
        {...props}
        className={twMerge("block dark:hidden", props.className)}
        src={LogoSvg}
      />
    </>
  )
}
